function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PopularCuisines.css';
import React, { memo, useState } from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
import { isNil, isNotNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink';
const CuisineCard = /*#__PURE__*/memo(_ref => {
  let {
    baseHref,
    cuisineName,
    countOfRestaurants,
    restaurantsText,
    analyticClick,
    image,
    alt
  } = _ref;
  if (countOfRestaurants <= 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RouterLink, {
    href: `${baseHref}${cuisineName}`,
    className: "cuisineCard",
    onClick: () => analyticClick(cuisineName)
  }, isNotNil(image) ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: alt,
    className: "cuisineImage"
  }) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "nameCuisines"
  }, cuisineName), /*#__PURE__*/React.createElement("p", {
    className: "restaurantsCount"
  }, countOfRestaurants, " ", restaurantsText)));
});
const PopularCuisines = /*#__PURE__*/memo(_ref2 => {
  let {
    params,
    fields
  } = _ref2;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [openMoreCards, setOpenMoreCards] = useState(false);
  const [cuisines, setCuisines] = useState([]);
  const types = 'type:Restaurant';
  const algoliaIndexes = get(params, 'SearchIndex');
  const facetName = get(fields, 'data.datasource.cuisines.targetItem.fieldNameItem.item.fieldName.value');
  const href = get(fields, 'data.datasource.overviewLink.jss.value.href');
  const title = get(fields, 'data.datasource.title.jss.value');
  const imagedTagMappings = get(fields, 'data.imagedTagMappings.values');
  const tagsToDisplay = get(fields, 'data.datasource.cuisines.targetItem.tagsToDisplay.values');
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const seeLessText = getDictionaryItem(moduleDictionary, 'SeeLess');
  const seeMoreText = getDictionaryItem(moduleDictionary, 'SeeMore');
  const restaurantsText = getDictionaryItem(moduleDictionary, 'Restaurants') || 'restaurants';
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const cuisineAnalyticsButtonClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), text);
  };
  const seeMoreAnalyticsButtonClick = textArray => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params), textArray);
  };
  const seeMoreButtonOnClick = () => {
    setOpenMoreCards(prev => !prev);
    seeMoreAnalyticsButtonClick([title, openMoreCards ? seeLessText : seeMoreText]);
  };
  const createOfPopularCuisines = function () {
    let facetTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const tagImageMappings = {};
    tagsToDisplay.forEach(tag => {
      const foundTag = imagedTagMappings.find(imagedTag => {
        const imagedTagMappingsTitle = get(imagedTag, 'cuisine.targetItem.title.value', '');
        return imagedTagMappingsTitle === tag.title.value;
      });
      if (foundTag) {
        const {
          src,
          alt
        } = foundTag.image.jss.value;
        tagImageMappings[tag.title.value] = {
          image: src ? src : null,
          alt: alt ? alt : null
        };
      } else {
        tagImageMappings[tag.title.value] = {
          image: null,
          alt: null
        };
      }
    });
    const cuisines = tagsToDisplay.reduce((acc, cuisine) => {
      const cuisineItem = _objectSpread(_objectSpread({
        cuisineName: cuisine.title.value
      }, tagImageMappings[cuisine.title.value]), {}, {
        countOfRestaurants: facetTags[cuisine.title.value]
      });
      if (facetTags[cuisine.title.value]) {
        acc.push(cuisineItem);
      }
      return acc;
    }, []);
    setCuisines(cuisines);
  };
  const algoliaRequest = () => {
    const itemFilters = {
      facets: [facetName],
      facetFilters: [types, facetName],
      hitsPerPage: 0
    };
    getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
      createOfPopularCuisines(response.facets.tags);
    }).catch(error => {
      console.log('error', error);
    });
  };
  React.useEffect(() => {
    algoliaRequest();
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('PopularCuisines component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [PopularCuisines component is empty: please provide data source]");
    }
    return null;
  }
  const showMoreOrLessCuisines = openMoreCards ? cuisines : cuisines.slice(0, 5);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "cuisinesGridContainer"
  }, showMoreOrLessCuisines.map((props, index) => /*#__PURE__*/React.createElement(CuisineCard, _extends({
    baseHref: `${href}?${facetName}=`,
    restaurantsText: restaurantsText,
    analyticClick: cuisineAnalyticsButtonClick
  }, props, {
    key: index
  }))), cuisines.length > 5 ? /*#__PURE__*/React.createElement("button", {
    className: `seeMoreAction ${openMoreCards ? 'seeLessBackground' : null}`,
    onClick: seeMoreButtonOnClick
  }, /*#__PURE__*/React.createElement("p", {
    className: "seeMoreButton"
  }, openMoreCards ? seeLessText : seeMoreText), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: `icon ${openMoreCards ? 'iconSeeLess' : 'iconSeeMore'}`
  })) : null));
});
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c67ay8h";
const ltrStyles = "l1fyubd6";
const rtlStyles = "ro6h409";
export default PopularCuisines;